import Inquiry from './inquiry'
import requireAuth from '../../require-auth'

export default requireAuth(Inquiry)



// WEBPACK FOOTER //
// ./src/components/pages/inquiry/index.ts